import { render, staticRenderFns } from "./WorkTaskApproveDialog.vue?vue&type=template&id=487f831c"
import script from "./WorkTaskApproveDialog.vue?vue&type=script&lang=ts"
export * from "./WorkTaskApproveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports